/* ==========================================================================
   SPEED KIT v1.0 — Runtime
   Wird mit defer geladen, blockiert also nie das Parsing.

   Module:
     1. Bild-Hygiene       decoding=async + loading=lazy fuer App-Inhalte
     2. Iframe-Lazyload    Fremd-Iframes erst nahe am Viewport laden
     3. Prefetch-Fallback  fuer Browser ohne Speculation Rules (Firefox)
     4. Idle-Warmup        verzoegerte Stylesheets aktivieren

   Debug:  ?speedkit=debug
   Aus:    ?speedkit=off
   ========================================================================== */
(function () {
  'use strict';

  var SEARCH = window.location.search;
  if (/[?&]speedkit=off/.test(SEARCH)) return;

  var DEBUG = /[?&]speedkit=debug/.test(SEARCH);
  var CFG = window.SpeedKit || {};

  function log() {
    if (!DEBUG) return;
    var args = ['%c[SpeedKit]', 'color:#c1121f;font-weight:700'];
    console.log.apply(console, args.concat(Array.prototype.slice.call(arguments)));
  }

  var onIdle =
    window.requestIdleCallback ||
    function (cb) {
      return window.setTimeout(function () {
        cb({ didTimeout: false, timeRemaining: function () { return 50; } });
      }, 200);
    };

  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var slowNet = !!(
    navigator.connection &&
    /(^|-)2g$/.test(navigator.connection.effectiveType || '')
  );

  /* ------------------------------------------------------------------------
     1) Bild-Hygiene
     Greift vor allem bei Bildern, die Apps nachtraeglich ins DOM schreiben
     (Judge.me, Bundles, Upsell-Widgets). Theme-eigene Bilder haben die
     Attribute bereits.
     ------------------------------------------------------------------------ */
  var imagesTouched = 0;

  function tidyImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img:not([data-sk])');
    var viewport = window.innerHeight || 800;

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('data-sk', '1');

      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');

      if (!img.hasAttribute('loading')) {
        var box = img.getBoundingClientRect();
        if (box.top > viewport * 1.25) {
          img.setAttribute('loading', 'lazy');
          imagesTouched++;
        }
      }
    }
  }

  /* ------------------------------------------------------------------------
     2) Iframe-Lazyload
     Fremd-Iframes (YouTube, Maps, Chat) werden erst geladen, wenn sie in die
     Naehe des Viewports kommen. Bereits sichtbare Iframes bleiben unangetastet.
     ------------------------------------------------------------------------ */
  var frameObserver = null;

  function getFrameObserver() {
    if (frameObserver || !('IntersectionObserver' in window)) return frameObserver;
    frameObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var frame = entries[i].target;
          frameObserver.unobserve(frame);
          var src = frame.getAttribute('data-sk-src');
          if (src) {
            frame.removeAttribute('data-sk-src');
            frame.setAttribute('src', src);
            log('iframe geladen', src);
          }
        }
      },
      { rootMargin: '600px 0px' }
    );
    return frameObserver;
  }

  function tidyFrames(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var frames = scope.querySelectorAll('iframe[src]:not([data-sk])');
    var viewport = window.innerHeight || 800;
    var observer = getFrameObserver();

    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i];
      frame.setAttribute('data-sk', '1');

      var src = frame.getAttribute('src') || '';
      // Nie anfassen: leere/inline Frames und Shopify-eigene Frames
      if (!src || src.indexOf('about:') === 0 || src.indexOf('javascript:') === 0) continue;
      if (/shopify\.com|shopifycdn|shopifysvc|shopifycloud|myshopify\.com/.test(src)) continue;

      if (!frame.hasAttribute('loading')) frame.setAttribute('loading', 'lazy');

      if (!observer) continue;
      var box = frame.getBoundingClientRect();
      if (box.top <= viewport * 1.5) continue; // schon (fast) sichtbar

      frame.setAttribute('data-sk-src', src);
      frame.removeAttribute('src');
      observer.observe(frame);
    }
  }

  /* ------------------------------------------------------------------------
     3) Prefetch-Fallback
     Chrome/Edge erledigen das ueber die Speculation Rules im <head>.
     Fuer alle anderen Browser hier ein schlanker Hover-Prefetch.
     ------------------------------------------------------------------------ */
  function supportsSpeculationRules() {
    return !!(
      window.HTMLScriptElement &&
      HTMLScriptElement.supports &&
      HTMLScriptElement.supports('speculationrules')
    );
  }

  function supportsLinkPrefetch() {
    var link = document.createElement('link');
    return !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
  }

  var EXCLUDED = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account|apps|tools|services|a|wpm|\.well-known)(?:$|\/|\?)/i;

  function setupPrefetchFallback() {
    if (supportsSpeculationRules()) {
      log('Speculation Rules aktiv - Fallback nicht noetig');
      return;
    }
    if (!supportsLinkPrefetch() || saveData || slowNet) return;

    var seen = Object.create(null);
    var budget = 12; // maximal 12 Vorladungen pro Seitenaufruf
    var timer = null;

    function prefetch(url) {
      if (budget <= 0 || seen[url]) return;
      seen[url] = true;
      budget--;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
      log('prefetch', url);
    }

    function candidate(event) {
      var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!anchor) return null;
      if (anchor.hasAttribute('download')) return null;
      if (anchor.target && anchor.target !== '' && anchor.target !== '_self') return null;
      if (/\bnofollow\b/i.test(anchor.rel || '')) return null;
      if (anchor.matches('.no-prefetch, [data-no-prefetch]')) return null;

      var url;
      try {
        url = new URL(anchor.href, location.href);
      } catch (e) {
        return null;
      }
      if (url.origin !== location.origin) return null;
      if (url.pathname === location.pathname && url.search === location.search) return null;
      if (EXCLUDED.test(url.pathname)) return null;
      return url.href;
    }

    function onEnter(event) {
      var url = candidate(event);
      if (!url) return;
      clearTimeout(timer);
      timer = setTimeout(function () { prefetch(url); }, 90);
    }

    function onLeave() {
      clearTimeout(timer);
    }

    document.addEventListener('pointerover', onEnter, { passive: true, capture: true });
    document.addEventListener('pointerout', onLeave, { passive: true, capture: true });
    document.addEventListener('touchstart', onEnter, { passive: true, capture: true });
    log('Prefetch-Fallback aktiv');
  }

  /* ------------------------------------------------------------------------
     4) Verzoegerte Stylesheets nachziehen
     Sicherheitsnetz, falls onload="this.media='all'" nicht gefeuert hat.
     ------------------------------------------------------------------------ */
  function activateDeferredStyles() {
    // Nur Stylesheets, die bewusst per onload-Trick verzoegert wurden -
    // echte Druck-Stylesheets bleiben unangetastet.
    var links = document.querySelectorAll('link[rel="stylesheet"][media="print"][onload]');
    for (var i = 0; i < links.length; i++) {
      links[i].media = 'all';
    }
    var preloads = document.querySelectorAll('link[rel="preload"][as="style"][data-sk-swap]');
    for (var j = 0; j < preloads.length; j++) {
      preloads[j].rel = 'stylesheet';
    }
  }

  /* ------------------------------------------------------------------------
     Start
     ------------------------------------------------------------------------ */
  function boot() {
    tidyImages(document);
    tidyFrames(document);
    setupPrefetchFallback();

    // Von Apps nachgeladene Inhalte ebenfalls behandeln
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        onIdle(function () {
          pending = false;
          tidyImages(document);
          tidyFrames(document);
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    onIdle(function () {
      activateDeferredStyles();
      log('bereit', { bilderNachgeruestet: imagesTouched, config: CFG });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Sicherheitsnetz: spaetestens nach 4 s Stylesheets freigeben
  window.setTimeout(activateDeferredStyles, 4000);
})();
